<template>
    <div>
        <div v-for="guess in guesses">{{guess}}</div>
    </div>
</template>

<script>
    import NameValue from "../../NameValue";
    import {mapGetters} from "vuex";

    export default {
        components: {NameValue},
        computed: {
            ...mapGetters(['allPosts']),
            guesses() {
                // WARNING stuff in the match array needs to be lowercase
                let games = [
                    {match: ['overwatch'], name: 'Overwatch'},
                    {match: ['leagueoflegends'], name: 'League Of Legends'},
                    {match: ['pathofexile'], name: 'Path of Exile'},
                    {match: ['fortnite'], name: 'Fortnite'},
                    {match: ['wow'], name: 'World of Warcraft'},
                    {match: ['pubattlegrounds', 'pubgxboxone'], name: 'PUBG'},
                    {match: ['destinythegame'], name: 'Destiny'}
                ];

                let total = 0;
                let res = [];

                games.forEach(g => {
                    let count = this.allPosts.map(d => d.data).filter(d => g.match.includes(d.subreddit.toLowerCase())).reduce((a, c) => a + 1, 0);
                    total += count;
                    let add = null;
                    if (count > 10)
                        add = `Casual ${g.name} player`;
                    if (count > 30)
                        add = `${g.name} Fan`;
                    if (count > 100)
                        add = `${g.name} Hardcore Player`;
                    if (add)
                        res.push(add)
                });


                // count instances of gaming and games too
                total += this.allPosts.map(d => d.data).filter(d => ['gaming', 'games'].includes(d.subreddit.toLowerCase())).reduce((a, c) => a + 1, 0);

                if (total > 100)
                    res.push('Hardcore Gamer');
                else if (total > 20)
                    res.push('Casual Gamer');

                return res;
            }
        }
    }
</script>

<style scoped>

</style>
